(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-block"] && !Shopify.designMode) return;
  try {
    class CountdownBlock extends HTMLElement {
    connectedCallback() {
      this.timeEl = this.querySelector('.countdown-block__time-value');
      if (!this.timeEl) return;

      this.tick();
      this.intervalId = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    tick() {
      const remaining = this.getRemainingMs();
      this.timeEl.textContent = this.formatRemaining(remaining);
    }

    getRemainingMs() {
      const target = this.resolveTargetDate();
      if (!target) return 0;

      const remaining = target.getTime() - Date.now();

      if (remaining <= 0 && this.isRecurring()) {
        const nextTarget = this.computeTargetDate();
        if (nextTarget) {
          this.saveTargetDate(nextTarget);
          return Math.max(0, nextTarget.getTime() - Date.now());
        }
      }

      return Math.max(0, remaining);
    }

    resolveTargetDate() {
      const stored = this.readStoredTarget();

      if (stored) {
        if (this.dataset.countdownType === 'fixed_date') {
          return stored;
        }

        if (stored.getTime() > Date.now()) {
          return stored;
        }
      }

      const computed = this.computeTargetDate();
      if (computed) {
        this.saveTargetDate(computed);
      }

      return computed;
    }

    isRecurring() {
      const type = this.dataset.countdownType;
      return type === 'midnight' || type === 'daily_time' || type === 'interval_days';
    }

    getStorageKey() {
      return `countdown-block-${this.dataset.blockId || 'default'}`;
    }

    getConfigHash() {
      return [
        this.dataset.countdownType,
        this.dataset.endDate,
        this.dataset.intervalDays,
        this.dataset.startDate,
        this.dataset.resetHour,
        this.dataset.resetMinute,
        this.dataset.cutoffHour,
        this.dataset.cutoffMinute
      ].join('|');
    }

    readStoredTarget() {
      try {
        const raw = window.localStorage.getItem(this.getStorageKey());
        if (!raw) return null;

        const data = JSON.parse(raw);
        if (!data || data.configHash !== this.getConfigHash()) return null;

        const target = new Date(data.targetTimestamp);
        if (Number.isNaN(target.getTime())) return null;

        return target;
      } catch {
        return null;
      }
    }

    saveTargetDate(target) {
      try {
        window.localStorage.setItem(
          this.getStorageKey(),
          JSON.stringify({
            targetTimestamp: target.getTime(),
            configHash: this.getConfigHash()
          })
        );
      } catch {
        return;
      }
    }

    computeTargetDate() {
      const type = this.dataset.countdownType;

      if (type === 'midnight') {
        return this.getNextDailyTime(0, 0);
      }

      if (type === 'daily_time') {
        const hour = Number.parseInt(this.dataset.cutoffHour, 10) || 0;
        const minute = Number.parseInt(this.dataset.cutoffMinute, 10) || 0;
        return this.getNextDailyTime(hour, minute);
      }

      if (type === 'interval_days') {
        const intervalDays = Number.parseInt(this.dataset.intervalDays, 10) || 1;
        const resetHour = Number.parseInt(this.dataset.resetHour, 10) || 0;
        const resetMinute = Number.parseInt(this.dataset.resetMinute, 10) || 0;
        const startDate = this.parseDate(this.dataset.startDate);

        if (!startDate) return null;

        startDate.setHours(resetHour, resetMinute, 0, 0);

        const intervalMs = intervalDays * 24 * 60 * 60 * 1000;
        let target = new Date(startDate.getTime());

        while (target.getTime() <= Date.now()) {
          target = new Date(target.getTime() + intervalMs);
        }

        return target;
      }

      if (type === 'fixed_date') {
        return this.parseDate(this.dataset.endDate);
      }

      return null;
    }

    getNextDailyTime(hour, minute) {
      const now = new Date();
      const target = new Date(now);
      target.setHours(hour, minute, 0, 0);

      if (target.getTime() <= now.getTime()) {
        target.setDate(target.getDate() + 1);
      }

      return target;
    }

    parseDate(value) {
      if (!value) return null;

      const normalized = value.trim().replace(' ', 'T');
      const parsed = new Date(normalized);

      if (Number.isNaN(parsed.getTime())) return null;

      return parsed;
    }

    formatRemaining(ms) {
      const totalSeconds = Math.max(0, Math.floor(ms / 1000));
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return `${hours}hr ${minutes}mins ${seconds}sec`;
    }
  }

  if (!customElements.get('countdown-block')) {
    customElements.define('countdown-block', CountdownBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["free-gift-progress"] && !Shopify.designMode) return;
  try {
    class FreeGiftProgressBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.giftThreshold) || 0;
      this.giftVariantId = parseInt(this.dataset.giftVariantId) || 0;
      this.fill = this.querySelector('[data-fgpb-fill]');
      this.beforeEl = this.querySelector('[data-fgpb-before]');
      this.afterEl = this.querySelector('[data-fgpb-after]');
      this.giftAdded = false;

      this.updateFromCart();
      this.bindEvents();
      this.interceptCartRequests();
    }

    async getCart() {
      const res = await fetch('/cart.js');
      return res.json();
    }

    setUnlocked(isUnlocked) {
      if (!this.beforeEl || !this.afterEl) return;
      this.beforeEl.style.display = isUnlocked ? 'none' : 'flex';
      this.afterEl.style.display = isUnlocked ? 'flex' : 'none';
    }

    async updateFromCart() {
      if (!this.threshold || !this.fill) return;
      try {
        const cart = await this.getCart();
        const total = cart.total_price;
        const pct = Math.min(100, Math.round((total / this.threshold) * 100));
        this.fill.style.width = pct + '%';

        const unlocked = total >= this.threshold;
        this.setUnlocked(unlocked);

        if (this.giftVariantId) {
          const alreadyInCart = cart.items.some(
            item => item.variant_id === this.giftVariantId
          );
          if (alreadyInCart) this.giftAdded = true;
          if (unlocked && !this.giftAdded) {
            await this.addGift();
          }
        }
      } catch (_) {}
    }

    async addGift() {
      if (this.giftAdded || !this.giftVariantId) return;
      this.giftAdded = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: this.giftVariantId, quantity: 1, properties: { _free_gift: 'true' } }]
          })
        });
        if (res.ok) {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        } else {
          this.giftAdded = false;
        }
      } catch (_) {
        this.giftAdded = false;
      }
    }

    bindEvents() {
      const refresh = () => this.updateFromCart();
      ['cart:updated', 'cart-update', 'cart:change', 'cart:refresh'].forEach(ev => {
        document.addEventListener(ev, refresh);
      });
    }

    interceptCartRequests() {
      if (window.__fgpbFetchPatched) return;
      window.__fgpbFetchPatched = true;
      const orig = window.fetch.bind(window);
      window.fetch = async (...args) => {
        const result = await orig(...args);
        const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
        if (/\/cart\/(add|change|update)/.test(url)) {
          setTimeout(() => {
            document.querySelectorAll('free-gift-progress-bar').forEach(el => el.updateFromCart());
          }, 600);
        }
        return result;
      };
    }
  }

  if (!customElements.get('free-gift-progress-bar')) {
    customElements.define('free-gift-progress-bar', FreeGiftProgressBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["free-gift-variant-progress"] && !Shopify.designMode) return;
  try {
    class FreeGiftVariantProgressBar extends HTMLElement {
    connectedCallback() {
      this.goal = parseInt(this.dataset.goal) || 3;
      this.giftVariantId = parseInt(this.dataset.giftVariantId) || 0;
      this.fill = this.querySelector('[data-fgvpb-fill]');
      this.beforeEl = this.querySelector('[data-fgvpb-before]');
      this.afterEl = this.querySelector('[data-fgvpb-after]');
      this.beforeTitleEl = this.querySelector('[data-fgvpb-before-title]');
      this.beforeDescEl = this.querySelector('[data-fgvpb-before-desc]');
      this.goalMet = false;
      this.giftAdded = false;

      this.beforeTitleTemplate = this.beforeTitleEl ? this.beforeTitleEl.innerHTML : '';
      this.beforeDescTemplate = this.beforeDescEl ? this.beforeDescEl.innerHTML : '';

      this.attachToPicker();
      this.interceptCartForGift();
    }

    extractCount(text) {
      const match = (text || '').match(/\d+/);
      return match ? parseInt(match[0]) : 0;
    }

    getSelectedCount() {
      const selected = document.querySelector('.svb-card--selected .svb-card__title');
      return selected ? this.extractCount(selected.textContent) : 0;
    }

    replacePlaceholder(html, needed) {
      return html.replace(/\[count-needed\]/g, needed);
    }

    updateUI(count) {
      const goal = this.goal;
      const needed = Math.max(0, goal - count);
      const pct = Math.min(100, Math.round((count / goal) * 100));

      if (this.fill) this.fill.style.width = pct + '%';

      const unlocked = count >= goal;
      this.goalMet = unlocked;

      if (!this.beforeEl || !this.afterEl) return;

      this.beforeEl.style.display = unlocked ? 'none' : 'flex';
      this.afterEl.style.display = unlocked ? 'flex' : 'none';

      if (!unlocked) {
        if (this.beforeTitleEl) {
          this.beforeTitleEl.innerHTML = this.replacePlaceholder(this.beforeTitleTemplate, needed);
        }
        if (this.beforeDescEl) {
          this.beforeDescEl.innerHTML = this.replacePlaceholder(this.beforeDescTemplate, needed);
        }
      }
    }

    attachToPicker() {
      const tryBind = () => {
        const picker = document.querySelector('subscription-variant-picker');
        if (!picker) return false;

        const count = this.getSelectedCount();
        this.updateUI(count > 0 ? count : 1);

        const observer = new MutationObserver((mutations) => {
          for (const m of mutations) {
            if (
              m.type === 'attributes' &&
              m.attributeName === 'class' &&
              m.target.classList.contains('svb-card') &&
              m.target.classList.contains('svb-card--selected')
            ) {
              const titleEl = m.target.querySelector('.svb-card__title');
              const count = titleEl ? this.extractCount(titleEl.textContent) : 0;
              if (count > 0) this.updateUI(count);
              break;
            }
          }
        });

        observer.observe(picker, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class']
        });

        return true;
      };

      if (!tryBind()) {
        const bodyObs = new MutationObserver(() => {
          if (tryBind()) bodyObs.disconnect();
        });
        bodyObs.observe(document.body, { childList: true, subtree: true });
      }
    }

    async addGift() {
      if (this.giftAdded || !this.giftVariantId) return;
      this.giftAdded = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: this.giftVariantId, quantity: 1, properties: { _free_gift: 'true' } }]
          })
        });
        if (!res.ok) this.giftAdded = false;
      } catch (_) {
        this.giftAdded = false;
      }
    }

    interceptCartForGift() {
      if (window.__fgvpbFetchPatched) return;
      window.__fgvpbFetchPatched = true;
      const orig = window.fetch.bind(window);
      window.fetch = async (...args) => {
        const result = await orig(...args);
        const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
        if (/\/cart\/add/.test(url) && result.ok) {
          const bodyStr = (args[1] && typeof args[1].body === 'string') ? args[1].body : '';
          const isOwnGiftAdd = bodyStr.includes('_free_gift');
          if (!isOwnGiftAdd) {
            document.querySelectorAll('free-gift-variant-progress-bar').forEach(el => {
              if (el.goalMet && !el.giftAdded) el.addGift();
            });
          }
        }
        return result;
      };
    }
  }

  if (!customElements.get('free-gift-variant-progress-bar')) {
    customElements.define('free-gift-variant-progress-bar', FreeGiftVariantProgressBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["subscription-variant"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('subscription-variant-picker')) {
    class SubscriptionVariantPicker extends HTMLElement {
      connectedCallback() {
        const variantsScript = this.querySelector('[data-svb-variants]');
        if (!variantsScript) return;

        this.variants = JSON.parse(variantsScript.textContent);
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.selectedVariantId = String(this.dataset.selectedVariantId || this.variants[0]?.id || '');
        this.isUpdating = false;
        this.skipLoopObserver = false;
        this.cards = Array.from(this.querySelectorAll('.svb-card'));

        this.cards.forEach((card) => {
          card.addEventListener('click', () => this.onCardClick(card));
        });

        const variantPicker = document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
        variantPicker?.addEventListener('change', (event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement) || !target.dataset.variantId) return;

          this.selectedVariantId = String(target.dataset.variantId);
          this.cards.forEach((item) => {
            const isSelected = String(item.dataset.variantId) === this.selectedVariantId;
            item.classList.toggle('svb-card--selected', isSelected);
            item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          });
          this.syncPrices();
        });

        this.bindLoopWidget();
        this.syncPrices();
      }

      bindLoopWidget() {
        const attach = () => {
          const loopWidget = document.querySelector('.loop-widget-container');
          if (!loopWidget || loopWidget.dataset.svbBound === 'true') return false;

          loopWidget.dataset.svbBound = 'true';
          loopWidget.addEventListener('click', (event) => {
            const option = event.target.closest('.loop-widget-purchase-option');
            if (option) {
              window.requestAnimationFrame(() => this.syncPrices());
            }
          });

          const frequencySelect = loopWidget.querySelector('.loop-widget-sp-selector');
          frequencySelect?.addEventListener('change', () => this.syncPrices());

          this.bindLoopPriceObserver(loopWidget);
          this.syncPrices();
          return true;
        };

        if (!attach()) {
          const observer = new MutationObserver(() => {
            if (attach()) observer.disconnect();
          });
          observer.observe(document.body, { childList: true, subtree: true });
        }
      }

      bindLoopPriceObserver(loopWidget) {
        if (this.loopPriceObserver) return;

        this.loopPriceObserver = new MutationObserver(() => {
          if (this.skipLoopObserver) return;

          const variant = this.getVariant(this.selectedVariantId);
          if (!variant) return;

          window.requestAnimationFrame(() => {
            this.skipLoopObserver = true;
            this.updateLoopWidgetPrices(variant);
            this.skipLoopObserver = false;
          });
        });

        this.loopPriceObserver.observe(loopWidget, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      onCardClick(card) {
        if (card.disabled) return;

        const variantId = String(card.dataset.variantId);
        if (variantId === this.selectedVariantId) return;

        this.selectedVariantId = variantId;
        this.cards.forEach((item) => {
          const isSelected = String(item.dataset.variantId) === variantId;
          item.classList.toggle('svb-card--selected', isSelected);
          item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });

        this.selectThemeVariant(variantId);
        this.syncPrices();
      }

      selectThemeVariant(variantId) {
        const variantPicker = document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
        const radio = variantPicker?.querySelector(`input[data-variant-id="${variantId}"]`);

        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (variantInput && variantInput.value !== variantId) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      isSubscriptionSelected() {
        const oneTimeSelected = document.querySelector(
          '.loop-widget-purchase-option-onetime.loop-widget-purchase-option-selected'
        );
        if (oneTimeSelected) return false;

        const subscribeSelected = document.querySelector(
          '.loop-widget-purchase-option:not(.loop-widget-purchase-option-onetime).loop-widget-purchase-option-selected'
        );
        if (subscribeSelected) return true;

        return this.dataset.subscriptionFirst === 'true';
      }

      getVariant(variantId) {
        return this.variants.find((variant) => String(variant.id) === String(variantId));
      }

      formatMoney(cents) {
        const numericCents = Number(cents);
        const amount = (numericCents / 100).toFixed(2);
        const amountNoDecimals = Math.round(numericCents / 100).toString();
        const amountWithComma = amount.replace('.', ',');

        if (this.moneyFormat) {
          return this.moneyFormat
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
            .replace(/\{\{\s*amount\s*\}\}/g, amount);
        }

        return '$' + amount;
      }

      syncPrices() {
        if (this.isUpdating) return;
        this.isUpdating = true;

        const isSubscription = this.isSubscriptionSelected();
        const selectedVariant = this.getVariant(this.selectedVariantId);

        this.cards.forEach((card) => {
          const variant = this.getVariant(card.dataset.variantId);
          if (!variant) return;

          const activePrice = isSubscription ? variant.subscriptionPrice : variant.price;
          const compareAt = variant.compareAtPrice;
          const saveAmount = compareAt > activePrice ? compareAt - activePrice : 0;
          const perLb = Math.round(activePrice / variant.lbCount);

          const saveEl = card.querySelector('[data-svb-save]');
          const saveAmountEl = card.querySelector('[data-svb-save-amount]');
          const compareEl = card.querySelector('[data-svb-compare]');
          const priceEl = card.querySelector('[data-svb-price]');
          const perLbEl = card.querySelector('[data-svb-per-lb]');

          if (saveEl && saveAmountEl) {
            if (saveAmount > 0) {
              saveAmountEl.textContent = this.formatMoney(saveAmount);
              saveEl.hidden = false;
            } else {
              saveEl.hidden = true;
            }
          }

          if (compareEl) {
            if (compareAt > activePrice) {
              compareEl.textContent = this.formatMoney(compareAt);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }

          if (priceEl) priceEl.textContent = this.formatMoney(activePrice);
          if (perLbEl) perLbEl.textContent = `${this.formatMoney(perLb)}/lb`;
        });

        if (selectedVariant) {
          this.skipLoopObserver = true;
          this.updateLoopWidgetPrices(selectedVariant);
          this.skipLoopObserver = false;
          this.updateAddToCartPrices(selectedVariant, isSubscription);
          this.updateStep2Discount(selectedVariant);
        }

        this.isUpdating = false;
      }

      updateStep2Discount(variant) {
        if (!variant) return;

        let discountPercent = Number(this.dataset.discountPercent || 10);

        if (variant.compareAtPrice > variant.subscriptionPrice) {
          discountPercent = Math.round(
            ((variant.compareAtPrice - variant.subscriptionPrice) / variant.compareAtPrice) * 100
          );
        }

        const section = this.closest('.shopify-section, [data-section-id]') || document;
        section.querySelectorAll('[data-svb-step2-discount]').forEach((discountEl) => {
          discountEl.textContent = `SAVE ${discountPercent}%`;
        });
      }

      updateAddToCartPrices(variant, isSubscription) {
        const activePrice = isSubscription ? variant.subscriptionPrice : variant.price;
        const compareAt = variant.compareAtPrice;
        const selector = `product-form-component[data-product-id="${this.dataset.productId}"] .add-to-cart-text__content, sticky-add-to-cart[data-product-id="${this.dataset.productId}"] .add-to-cart-text__content`;

        document.querySelectorAll(selector).forEach((content) => {
          let pricesEl = content.querySelector('[data-svb-atc-prices]');

          if (!pricesEl) {
            pricesEl = document.createElement('span');
            pricesEl.className = 'svb-atc-prices';
            pricesEl.dataset.svbAtcPrices = '';
            pricesEl.innerHTML =
              '<span class="svb-atc-separator">-</span><span class="svb-atc-compare" data-svb-atc-compare></span><span class="svb-atc-price" data-svb-atc-price></span>';
            content.appendChild(pricesEl);
          }

          const compareEl = pricesEl.querySelector('[data-svb-atc-compare]');
          const priceEl = pricesEl.querySelector('[data-svb-atc-price]');

          if (compareEl) {
            if (compareAt > activePrice) {
              compareEl.textContent = this.formatMoney(compareAt);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }

          if (priceEl) {
            priceEl.textContent = this.formatMoney(activePrice);
          }

          pricesEl.hidden = false;
        });
      }

      updateLoopWidgetPrices(variant) {
        const loopWidget = document.querySelector('.loop-widget-container');
        if (!loopWidget) return;

        const subscribeCompareEls = loopWidget.querySelectorAll(
          '.loop-widget-purchase-option:not(.loop-widget-purchase-option-onetime) .loop-widget-purchase-option-compare-at-price'
        );
        const subscribePriceEls = loopWidget.querySelectorAll(
          '.loop-widget-purchase-option:not(.loop-widget-purchase-option-onetime) .loop-widget-purchase-option-price'
        );
        const oneTimeCompareEls = loopWidget.querySelectorAll(
          '.loop-widget-purchase-option-onetime .loop-widget-purchase-option-compare-at-price'
        );
        const oneTimePriceEls = loopWidget.querySelectorAll(
          '.loop-widget-purchase-option-onetime .loop-widget-purchase-option-price'
        );

        const formattedSubscriptionPrice = this.formatMoney(variant.subscriptionPrice);
        const formattedCompareAt = this.formatMoney(variant.compareAtPrice);
        const formattedOneTimePrice = this.formatMoney(variant.price);

        subscribePriceEls.forEach((el) => {
          if (el.textContent.trim() !== formattedSubscriptionPrice) {
            el.textContent = formattedSubscriptionPrice;
          }
        });

        subscribeCompareEls.forEach((el) => {
          if (variant.compareAtPrice > variant.subscriptionPrice) {
            if (el.textContent.trim() !== formattedCompareAt) {
              el.textContent = formattedCompareAt;
            }
            el.classList.remove('loop-display-none');
          } else {
            el.classList.add('loop-display-none');
          }
        });

        oneTimePriceEls.forEach((el) => {
          if (el.textContent.trim() !== formattedOneTimePrice) {
            el.textContent = formattedOneTimePrice;
          }
        });

        oneTimeCompareEls.forEach((el) => {
          if (variant.compareAtPrice > variant.price) {
            if (el.textContent.trim() !== formattedCompareAt) {
              el.textContent = formattedCompareAt;
            }
            el.classList.remove('loop-display-none');
          } else {
            el.classList.add('loop-display-none');
          }
        });
      }
    }

    customElements.define('subscription-variant-picker', SubscriptionVariantPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
